<template>
  <v-container fluid grid-list-lg pa-0 ma-0>
    <v-card flat>
      <v-card-text>
        <v-container fluid pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs6 sm4>
              <AmountThreshold v-model="fields.amount" :disabled="schedule.recurring_status_id > 2"></AmountThreshold>

              <v-layout row class="ma-0 mt-1" v-if="selectedTerminal.is_cashdiscount && schedule.request_type !== 'ach'">
                <v-flex grow class="pa-1 pl-2 caption primary white--text">
                  ${{ priceAdjustmentFee }}
                </v-flex>
                <v-flex shrink class="pa-1 pl-2 pr-2 pt-2 caption primary text-truncate white--text">
                  Price Adj Fee
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 sm4>
              <RecurringFrequencyDropdown v-model="fields.frequency" :disabled="schedule.recurring_status_id > 2" :showNone="false" @input="handleChange('frequency')"></RecurringFrequencyDropdown>
            </v-flex>

            <v-flex xs6 sm4>
              <v-menu
                ref="scheduleModalStartDateModal"
                :close-on-content-click="false"
                v-model="scheduleModalStartDateModal"
                :nudge-right="40"
                :return-value.sync="fields.start_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="formattedStartDate"
                  :disabled="schedule.recurring_status_id > 2"
                  :rules="recurringStartRules"
                  append-icon="fa-calendar"
                  readonly
                  box
                  hide-details
                />
                <v-date-picker
                  v-model="fields.start_date"
                  :min="minimumStartDate"
                  @input="$refs.scheduleModalStartDateModal.save(fields.start_date); handleChange('start_date');"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                v-if="fields.ongoing"
                label="End Date"
                v-model="formattedEndDate"
                :rules="recurringEndRules"
                append-icon="fa-calendar"
                box
                hide-details
              ></v-text-field>
              <v-menu
                v-else
                ref="scheduleModalEndDateModal"
                :close-on-content-click="false"
                v-model="scheduleModalEndDateModal"
                :nudge-right="40"
                :return-value.sync="fields.end_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="formattedEndDate"
                  :disabled="schedule.recurring_status_id > 2"
                  :rules="recurringEndRules"
                  append-icon="fa-calendar"
                  readonly
                  box
                  hide-details
                ></v-text-field>
                <v-date-picker
                  v-model="fields.end_date"
                  :min="minimumEndDate"
                  @input="$refs.scheduleModalEndDateModal.save(fields.end_date); handleChange('end_date');"
                ></v-date-picker>
              </v-menu>

              <v-checkbox
                label="Ongoing"
                v-model="fields.ongoing"
                :disabled="schedule.recurring_status_id > 2"
                color="primary"
                box
                hide-details
                class="ma-0"
              ></v-checkbox>
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                label="# of Payments"
                type="number"
                v-model.number="fields.payment_count"
                :disabled="schedule.recurring_status_id > 2 || !fields.start_date || !fields.frequency"
                append-icon="fa-hashtag"
                box
                hide-details
                @input="handleChange('payments')"
                :readonly="fields.ongoing"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-textarea
                label="Notes"
                v-model="fields.notes"
                :disabled="schedule.recurring_status_id > 2"
                box
                hide-details
                rows="2"
              ></v-textarea>
            </v-flex>
          </v-layout>

          <v-divider class="primary"></v-divider>

          <v-layout row wrap>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="save" :disabled="schedule.recurring_status_id > 2 || saveDisabled">Save Schedule</v-btn>
            <v-btn color="error" @click="cancel" :disabled="schedule.recurring_status_id > 2">Cancel Schedule</v-btn>
          </v-layout>

        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import ObjectDiff from '@/mixins/objectDiff'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'

import AmountThreshold from '@/components/terminal/AmountThreshold.vue'
import CardExpiration from '@/components/forms/CardExpiration.vue'
import CardNumber from '@/components/forms/CardNumber.vue'
import RecurringFrequencyDropdown from '@/components/forms/RecurringFrequencyDropdown.vue'

export default {
  components: {
    AmountThreshold,
    CardExpiration,
    CardNumber,
    RecurringFrequencyDropdown
  },

  mixins: [
    ApiMixin,
    AuthMixin,
    CashDiscountMixin,
    DisplayMixin,
    ObjectDiff,
    RecurringMixin,
    StoreMixin
  ],

  data: function () {
    return {
      selectedTerminal: {},
      terminalId: null,

      scheduleModalStartDateModal: false,
      scheduleModalEndDateModal: false,

      recurringStartRules: [
        (v) => !!v || 'Recurring start date is required'
      ],
      recurringEndRules: [
        (v) => !!v || 'Recurring end date is required'
      ],
      nameRules: [
        (v) => !!v || 'Name is required'
      ],
      // expirationRules: [
      //   (v) => !!v || 'Expiration is required'
      // ],

      // paymentCount: 0,

      fields: this.defaultFields(),
      fieldsCurrent: this.defaultFields()
    }
  },

  props: {
    schedule: Object,
    scheduledTransactions: Array
  },

  mounted () {
    if (this.schedule) {
      if (this.schedule.request_type === 'ach' && this.terminalsACHCanCharge && this.terminalsACHCanCharge.length) {
        this.terminal = this.terminalsACHCanCharge[0].terminal_id
      } else {
        this.terminal = this.terminalsCardCanCharge[0].terminal_id
      }

      this.fields.is_installment = this.schedule.is_installment

      this.fields.billing_name = this.schedule.billing_name
      this.fields.billing_address = this.schedule.billing_address
      this.fields.billing_city = this.schedule.billing_city
      this.fields.billing_state = this.schedule.billing_state
      this.fields.billing_country = this.schedule.billing_country
      this.fields.billing_postalcode = this.schedule.billing_postal_code
      this.fields.billing_phone = this.schedule.billing_phone
      this.fields.billing_email = this.schedule.billing_email

      this.fields.order_number = this.schedule.order_number
      this.fields.customer_po = this.schedule.customer_po
      this.fields.custom_field_1 = this.schedule.custom_field_1
      this.fields.custom_field_2 = this.schedule.custom_field_2
      this.fields.custom_field_3 = this.schedule.custom_field_3
      this.fields.notes = this.schedule.notes

      this.fields.notify = this.schedule.notify
      this.fields.last_four = this.schedule.last_four

      if (this.schedule.request_type === 'ach') {
        this.fields.ach_account_type = this.schedule.ach_account_type
      } else {
        this.fields.card_expiration = this.schedule.card_expiration_yymm.slice(-2) + ' / ' + this.schedule.card_expiration_yymm.slice(0, 2)
      }

      // this.scheduleAmount = parseFloat((this.schedule.amount - this.schedule.fee_amount) / 100)
      this.fields.amount = parseFloat((this.schedule.total_amount - this.schedule.fee_amount) / 100)

      this.fields.fee = parseFloat(this.schedule.fee_amount / 100)
      this.fields.is_fee_waived = this.schedule.is_fee_waived

      this.fields.frequency = this.schedule.recurring_type
      this.fields.start_date = Moment.utc(this.schedule.start).format('YYYY-MM-DD')

      if (!this.schedule.end) {
        this.fields.ongoing = true
      } else {
        this.fields.end_date = Moment.utc(this.schedule.end).format('YYYY-MM-DD') === '2099-12-31' ? '' : Moment.utc(this.schedule.end).format('YYYY-MM-DD')
        this.fields.ongoing = !!(Moment.utc(this.schedule.end).format('YYYY-MM-DD') === '2099-12-31')
      }

      this.fields.payment_count = this.fields.ongoing ? 0 : this.calculatePaymentCountWithEndDate(this.fields.frequency, this.fields.start_date, this.fields.end_date)

      this.fieldsCurrent = Object.assign({}, this.fields)
    }
  },

  computed: {
    terminal: {
      get () {
        return this.terminalId
      },

      set (value) {
        if (this.schedule.request_type === 'ach') {
          let terminal = this.terminalsACHCanCharge.find(terminal => terminal.terminal_id === value)
          if (terminal) {
            this.terminalId = value
            this.selectedTerminal = terminal
          }
        } else {
          let terminal = this.terminalsCardCanCharge.find(terminal => terminal.terminal_id === value)
          if (terminal) {
            this.terminalId = value
            this.selectedTerminal = terminal
          }
        }

        this.$store.commit('SELECT_ACCOUNT', this.selectedTerminal.account_id)
      }
    },

    priceAdjustmentFee: function () {
      if (this.fields.waive_fee) {
        return ''
      }
      return this.calculateCashDiscountFee(this.fields.amount)
    },

    formattedStartDate () {
      return this.fields.start_date ? Moment(this.fields.start_date).format('MMM-DD-YYYY') : ''
    },
    formattedEndDate () {
      return this.fields.end_date ? Moment(this.fields.end_date).format('MMM-DD-YYYY') : ''
    },
    minimumStartDate: function () {
      return Moment().format('YYYY-MM-DD')
    },
    minimumEndDate: function () {
      return Moment(this.fields.start_date, 'YYYY-MM-DD').add(2, 'days').format('YYYY-MM-DD')
    },

    recurringEndDate: function () {
      return this.fields.end_date
    },

    recurringOngoing: function () {
      return this.fields.ongoing
    },

    saveDisabled: function () {
      return !Object.keys(this.fullDiff(this.fieldsCurrent, this.fields)).length
    }
  },

  methods: {
    defaultFields () {
      return {
        is_installment: false,
        payment_count: 0,

        billing_name: null,
        billing_address: null,
        billing_city: null,
        billing_state: null,
        billing_country: null,
        billing_postalcode: null,
        billing_phone: null,
        billing_email: null,

        order_number: null,
        customer_po: null,
        custom_field_1: null,
        custom_field_2: null,
        custom_field_3: null,
        notes: null,

        notify: false,

        frequency: 'none',
        start_date: '',
        end_date: '',
        ongoing: false,

        amount: 0.00,
        fee: 0.00,
        fee_waived: 0.00,
        is_fee_waived: false,

        last_four: null,
        card_expiration: '',
        ach_account_type: 'CHECKING',

        card_number: null,
        card_cvv: null,
        ach_routing_number: null,
        ach_account_number: null
      }
    },

    async save () {
      try {
        if (!this.schedule || !this.schedule.id) {
          throw new Error('Unable to identify transaction')
        }

        let options = {
          recurring_type: this.fields.frequency,
          start: this.fields.start_date,
          end: this.fields.ongoing ? '2099-12-31' : this.fields.end_date,

          total_amount: (Number(this.fields.amount) + Number(this.priceAdjustmentFee)).toFixed(2),
          // fee_amount: this.fields.fee,
          fee_amount: this.priceAdjustmentFee,

          notify: this.fields.notify,
          installment_count: Number(this.fields.payment_count),
          notes: this.fields.notes
        }

        // options.is_installment = this.schedule.is_installment

        // options.billing_postalcode = this.fields.billing_postalcode
        // options.billing_phone = this.fields.billing_phone
        // options.billing_email = this.fields.billing_email

        // options.is_fee_waived = this.schedule.is_fee_waived
        // options.fee_waived = this.fields.fee_waived

        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'put',
          url: `/schedules/${this.schedule.id}`,
          data: options
        })

        if (result.data) {
          if (!result.data.error) {
            Bus.$emit('closeOptionsModal')
            Bus.$emit('openModal', {status: 'success', message: 'Schedule Modified'})
          } else {
            throw new Error('Error while modifying schedule')
          }
        } else {
          throw new Error('Unexpected Error')
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    async cancel () {
      try {
        if (!this.schedule || !this.schedule.id) {
          throw new Error('Unable to identify transaction')
        }

        if (confirm('Are you sure you would like to cancel this recurring schedule?')) {
          Bus.$emit('openWaitModal')
          let result = await this.api({
            method: 'delete',
            url: `/schedules/${this.schedule.id}`
          })

          if (result.data) {
            if (!result.data.error) {
              Bus.$emit('openModal', {status: 'success', message: 'Schedule Cancelled'})
            } else {
              throw new Error('Error while cancelling schedule')
            }
          } else {
            throw new Error('Unexpected Error')
          }
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    calculateCashDiscountFee (amount) {
      if (this.fields.is_fee_waived) {
        return 0
      }

      if (this.schedule.request_type === 'ach') {
        return 0
      }

      return this.calculateFee(this.selectedTerminal, amount)
    },

    handleChange (field) {
      let changes = this.handleRecurringFieldChange(field, this.fields)

      for (let change in changes) {
        this.$set(this.fields, change, changes[change])
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedules/Modify.vue